import { Button, Menu, MenuItem } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import * as React from "react";
import styled from "styled-components";

import { useCommonHooks } from "../hooks";
import { ETLCodes } from "../locales";

export interface UserMenuProps {}

const Container = styled.div``;

const StyledMenu = styled(Menu)`
  /* background-color: white !important;
  color: black !important; */
`;

export const UserMenu: React.FunctionComponent<UserMenuProps> = (props) => {
  const { t, fullUserName, logout } = useCommonHooks();
  return (
    <Container>
      <Popover2
        content={
          <StyledMenu>
            <MenuItem
              icon="log-out"
              text={t(ETLCodes.Logout)}
              onClick={() => logout()}
            />
          </StyledMenu>
        }
        position="bottom-right"
        minimal
      >
        <Button
          rightIcon="caret-down"
          icon="person"
          text={fullUserName}
          minimal
          large
        />
      </Popover2>
    </Container>
  );
};
